<template>
  <div class="app-mnp-in-data-input">
    <div class="form-wrapper">
      <b-form
        class="mnp-in-data-input"
        :id="'form' + _uid"
      >
        <b-form-group label="Rufnummer" label-class="visually-hidden" class="msisdn-group">
          <b-row class="mnp-input-row">
            <b-col md="" sm="12">
              <label for="msisdn" class="mandatory d-inline-block">
                <slot name="lblMsisdn">Rufnummer</slot>
              </label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                id="msisdn"
                name="portationMsisdn"
                type="text"
                v-model.trim="portationMsisdn_"
                required
                @input="$v.portationMsisdn.$touch"
                :state="isValid('portationMsisdn')"
              >
              </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <ProviderList
          :invalid.sync="dataInvalid"
          :selected-keys.sync="selectedKeys_">
        </ProviderList>
        <b-form-group label="Name" label-class="visually-hidden" class="mb-0">
          <b-form-group class="gender-group" label-for="gender-group">
            <b-row class="mnp-input-row">
              <b-col md="" sm="12">
                <label for="gender" class="mandatory d-inline-block">
                  <slot name="lblGender">Anrede</slot>
                </label>
              </b-col>
              <b-col md="" sm="12">
                <b-form-radio-group
                  id="gender"
                  v-model="person_.gender"
                  required
                  @input="$v.person.gender.$touch"
                  :state="isValid('gender', 'person')"
                >
                  <b-form-radio name="gender" value="MALE">Herr</b-form-radio>
                  <b-form-radio name="gender" value="FEMALE">Frau</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group class="first-name-group" label-for="first-name-group">
            <b-row class="mnp-input-row">
              <b-col md="" sm="12">
                <label for="first-name" class="mandatory d-inline-block">
                  <slot name="lblFirstName">Vorname</slot>
                </label>
              </b-col>
              <b-col md="" sm="12">
                <b-form-input
                  id="first-name"
                  name="firstName"
                  type="text"
                  required
                  v-model="person_.firstName"
                  @input="$v.person.firstName.$touch"
                  :state="isValid('firstName', 'person')">
                </b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group class="last-name-group" label-for="last-name-group">
            <b-row class="mnp-input-row">
              <b-col md="" sm="12">
                <label for="last-name" class="mandatory d-inline-block">
                  <slot name="lblLastName">Nachname</slot>
                </label>
              </b-col>
              <b-col md="" sm="12">
                <b-form-input
                  id="last-name"
                  name="lastName"
                  type="text"
                  required
                  v-model="person_.lastName"
                  @input="$v.person.lastName.$touch"
                  :state="isValid('lastName', 'person')">
                </b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
        </b-form-group>
        <b-form-group label="Geburtstag" label-class="visually-hidden" class="birth-date-group">
          <b-row class="mnp-input-row">
            <b-col md="" sm="12">
              <label :for="'birthdate' + _uid" class="mandatory"><slot name="lblBirthDate">Geburtsdatum</slot></label>
            </b-col>
            <b-col>
              <b-input-group class="mb-3">
                <b-form-input
                  :id="'birthdate' + _uid"
                  type="text"
                  name="birthDate"
                  v-model="person_.birthDate"
                  required
                  @input="$v.person.birthDate.$touch"
                  :state="isValid('birthDate', 'person')"
                  placeholder="TT.MM.JJJJ"
                  autocomplete="off"
                  aria-describedby="birthdate-live-feedback"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-bind="calendarSettings || {}"
                    button-only
                    right
                    required
                    @input="$v.person.birthDate.$touch"
                    :state="isValid('birthDate', 'person')"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    @context="selectDate"
                    :aria-controls="'birthdate' + _uid"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-form-invalid-feedback id="birthdate-live-feedback">
                  <slot v-if="$v.person.birthDate.validDateFormat === false" name="birthdateFormatLiveFeedback">Ungültiges Format. Bitte wie folgt eingeben: TT.MM.JJJJ</slot>
                </b-form-invalid-feedback>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { helpers, required, sameAs } from 'vuelidate/lib/validators'
import ProviderList from '@/components/process/generic/Mnp/MnpIn/ProviderList.vue'
import { validDate, validDateFormat } from '@/validators/date'
import isValid from '@/mixins/isValid'
import { validationMixin } from 'vuelidate'
import syncProperty from '@/mixins/syncProperty'
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)
export default {
  name: 'DataInput',
  data () {
    return {
      dataInvalid: true
    }
  },
  props: {},
  components: {
    BFormGroup,
    BFormInput,
    BForm,
    ProviderList
  },
  computed: {
    calendarSettings () {
      return this.$config.calendar.calendarSettings
    }
  },
  methods: {
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.person.birthDate = ctx.selectedFormatted
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('selectedKeys', 'selectedKeys_'),
    syncProperty('person', 'person_'),
    syncProperty('portationMsisdn', 'portationMsisdn_')
  ],
  watch: {
    '$v.$invalid': function (newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  mounted () {
    this.$emit('update:invalid', this.$v.$invalid)
  },
  validations () {
    return {
      portationMsisdn: { required, isPhoneNumber },
      person: {
        gender: { required },
        firstName: { required },
        lastName: { required },
        birthDate: { required, validDate, validDateFormat }
      },
      dataInvalid: {
        sameAs: sameAs(() => false)
      }
    }
  }
}
</script>
